<template>
  <div :class="classes">
    <slot></slot>
  </div>
</template>

<script>
import Emitter from '../../mixins/emitter'
const PREFIX_CLS = 'checkbox-group'

export default {
  name: 'TCheckboxGroup',
  provide() {
    return {
      groupVM: this
    }
  },
  mixins: [Emitter],
  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    },
    size: {
      type: String,
      default: '',
      validator(val) {
        /* istanbul ignore next */
        return ['lg', 'sm', ''].includes(val)
      }
    },
    type: {
      type: String,
      default: '',
      validator(val) {
        /* istanbul ignore next */
        return ['button', ''].includes(val)
      }
    },
    vertical: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentValue: this.value
    }
  },
  computed: {
    classes() {
      return [
        PREFIX_CLS,
        {
          [`${PREFIX_CLS}--${this.size}`]: !!this.size,
          [`${PREFIX_CLS}--inline`]: !this.vertical,
          [`${PREFIX_CLS}--${this.type}`]: !!this.type
        }
      ]
    }
  },
  watch: {
    value(newVal) {
      this.currentValue = newVal
    }
  },
  methods: {
    $_updateValue(val, checked) {
      const index = this.currentValue.indexOf(val)
      if (index < 0) {
        this.currentValue.push(val)
      } else {
        !checked && this.currentValue.splice(index, 1)
      }
      this.$_emitEvents(this.currentValue)
    },
    $_onChange(data) {
      this.currentValue = data
      this.$_emitEvents(data)
    },
    $_emitEvents(data) {
      this.$emit('input', data)
      this.$emit('change', data)
      // NOTE: 用于form验证
      this.dispatch('TFormItem', 'g-on-form-change', data)
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/module/checkbox/checkbox-group.vue